import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

let data = {
    namespaced: true,
    state: {
        userInfo: {},
        uid: "" //base64加密后的unionid
    },
    mutations: {
        UPDATE_APPDATA(state, options) {
            Object.keys(options).forEach(key => {
                state[key] = options[key];
            });
        }
    },
    actions: {}
};

const store = new Vuex.Store(data);
export default store;
